import React from "react";
import { Table, Select, Card, Button, Row, Col, Spin } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "Common/Footer";
import { useNavigate } from "react-router-dom";
import SkillReportService from "Services/AdminServices/ReportServices/SkillsReport";

const { Option } = Select;

function SkillsReport() {
  const {
    filteredData,
    selectedSkills,
    selectedDepartment,
    skills,
    departments,
    columns,
    loading,
    handleSkillsChange,
    handleDepartmentChange,
    handleDownloadReport,
  } = SkillReportService();

  const navigate = useNavigate();
  const back = () => {
    navigate(-1);
  };

  // Safe skills options
  const skillOptions = Array.isArray(skills)
    ? skills.map((skill) => ({
        value: skill.id,
        label: skill.name || "Unnamed Skill",
      }))
    : [];

  // Safe department options
  const departmentOptions = Array.isArray(departments) ? departments : [];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        className="card-professional"
        title="Skills Report"
        extra={
          <Button type="default" onClick={back}>
            Back
          </Button>
        }
      >
        {/* Filters Section */}
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} md={8}>
            <div className="form-group">
              <label style={{ display: "block", marginBottom: 8, fontWeight: 500 }}>
                Select Department
              </label>
              <Select
                style={{ width: "100%" }}
                placeholder="Select department (optional)"
                onChange={handleDepartmentChange}
                value={selectedDepartment}
                allowClear
                loading={loading}
              >
                <Option value="">All Departments</Option>
                {departmentOptions.map((dept) => (
                  <Option key={dept.id} value={dept.id}>
                    {dept.name}
                  </Option>
                ))}
              </Select>
              <small style={{ color: "#666", marginTop: 4, display: "block" }}>
                Select a department to filter skills and employees
              </small>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div className="form-group">
              <label style={{ display: "block", marginBottom: 8, fontWeight: 500 }}>
                Select Skills
              </label>
              <Select
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder={
                  selectedDepartment
                    ? "Select skills from department"
                    : "Select skills (all departments)"
                }
                options={skillOptions}
                onChange={handleSkillsChange}
                value={selectedSkills}
                loading={loading}
                disabled={!skillOptions.length}
              />
              <small style={{ color: "#666", marginTop: 4, display: "block" }}>
                {selectedDepartment
                  ? `Select one or more skills from the department. API will be called for each selection.`
                  : `Select one or more skills from all departments. API will be called for each selection.`}
              </small>
            </div>
          </Col>
        </Row>

        {/* Action Button */}
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col>
            <div style={{ color: "#666" }}>
              {Array.isArray(selectedSkills) && selectedSkills.length > 0
                ? `Showing employees with ${selectedSkills.length} selected skill(s)`
                : "Please select skills to view employees"}
              {selectedDepartment && ` in selected department`}
            </div>
          </Col>
          <Col>
            <Button
              className="btn-primary"
              onClick={handleDownloadReport}
              disabled={!selectedSkills.length || !filteredData.length}
            >
              <i className="fa fa-download" aria-hidden="true"></i>&nbsp; Download Skills Report
            </Button>
          </Col>
        </Row>

        {/* Data Table */}
        <div className="row mb-3">
          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Spin size="large" />
            </div>
          ) : (
            <Table
              className="custom-table"
              bordered
              dataSource={Array.isArray(filteredData) ? filteredData : []}
              columns={columns}
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} employees`,
              }}
              rowKey="id"
              loading={loading}
              scroll={{ x: 800 }}
              locale={{
                emptyText:
                  selectedSkills.length > 0
                    ? "No employees found with selected skills"
                    : "Please select skills to view employees",
              }}
            />
          )}
        </div>
      </Card>
      <Footer />
    </DashboardLayout>
  );
}

export default SkillsReport;
